export default {
  title: 'ضمیمه ها',
  previous: 'قبلی',
  next: 'بعدی',
  downloadText: 'برای دانلود کلیک کنید',
};
